import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    css: css`
        margin-bottom: 15px;
    `,
    variant: "primary",
};
orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "primary",
    },
};

orderUploadErrorsModalStyles.modal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalTitle: css`
            padding: 10px 20px;
        `,
        modalContent: css`
            padding: 20px;
            overflow-y: auto;
        `,
    },
}
